import { defineComponent as r, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ t("mask", { id: "addf14c6-b97a-4d74-b291-c39dee144b07" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#addf14c6-b97a-4d74-b291-c39dee144b07)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#d80027" d="M35.5 256h444l32.5-66.8V0H322.8L256 31.8v444.6L189.2 512H0V322.8z"></path><path fill="#0052b4" d="M479.5 256h-444L0 189.2V0h189.2L256 31.8v444.6l66.8 35.6H512V322.8z"></path><path fill="#eee" d="M189.2 0h133.6v189.2H512v133.6H322.8V512H189.2V322.8H0V189.2h189.2z"></path><path fill="#496e2d" d="M322.8 256a66.8 66.8 0 1 1-133.6 0c0-36.9 66.8-66.8 66.8-66.8s66.8 30 66.8 66.8z"></path><path fill="#0052b4" d="M189.2 256a66.8 66.8 0 1 1 133.6 0"></path><path fill="#d80027" d="M218.4 222.6v41.7a37.6 37.6 0 1 0 75.2 0v-41.7z"></path>', 6), g = { fill: "none" }, V = ["r"], z = /* @__PURE__ */ r({
  __name: "do",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), d = o(() => 256 + e.strokeWidth / 2);
    return (b, x) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      v,
      t("g", m, [
        e.flagName ? (s(), i("title", k, h(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, _));
  }
});
export {
  z as default
};
//# sourceMappingURL=do-9a650286.js.map
